import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 border-gray-200 dark:border-gray-700", // Atualizado para modo escuro
  {
    variants: {
      variant: {
        default: "bg-white text-primary-foreground hover:bg-primary/90 dark:bg-gray-800 dark:text-gray-100", // Atualizado para modo escuro
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90 dark:bg-gray-800 dark:text-gray-100", // Atualizado para modo escuro
        outline:
          "border border-input bg-white hover:bg-accent hover:text-accent-foreground dark:bg-gray-800 dark:border-gray-700 dark:text-gray-100", // Atualizado para modo escuro
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80 dark:bg-gray-800 dark:text-gray-100", // Atualizado para modo escuro
        ghost: "hover:bg-accent hover:text-accent-foreground dark:bg-gray-800 dark:text-gray-100", // Atualizado para modo escuro
        link: "text-primary underline-offset-4 hover:underline dark:text-gray-100", // Atualizado para modo escuro
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button"
    return (
      <Comp
        className={cn(
          buttonVariants({
            variant,
            size,
            className: `bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-gray-100 ${className} ` 
          }),
          "transition-colors duration-200"
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"

export { Button, buttonVariants }
